<div class="rs-wrapper-v4 default-space-between-components youtube-all-container">
    <h3>{{ 'video_tutorials_title' | translate }}</h3>
    <p>{{ 'video_tutorials_subtitle' | translate }}</p>
    <app-slide class="display-none-true" (draggingEvent)="receiveEvent($event)" [margin]="23" [elementWidth]="400">
        <div class="youtube-container">
            <div>
                <iframe src="https://www.youtube.com/embed/Wac2_fitDIU"
                    title="YouTube video player" frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
                <p class="color-heading">¿Qué es y cómo funciona Saldoar?</p>
            </div>
            <div>
                <iframe src="https://www.youtube.com/embed/FidYHSgp9ss"
                    title="YouTube video player" frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
                <p class="color-heading">¿Cómo retirar saldo PayPal?</p>
            </div>
            <div>
                <iframe src="https://www.youtube.com/embed/ORRuoDQxLDw"
                    title="YouTube video player" frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
                <p class="color-heading">¿Cómo recargar saldo PayPal?</p>
            </div>
        </div>
    </app-slide>
    <div class="youtube-container display-none-false">
        <div>
            <iframe src="https://www.youtube.com/embed/Wac2_fitDIU"
                title="YouTube video player" frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen></iframe>
            <h5>{{ 'video_tutorials_p' | translate }}</h5>
        </div>
        <div>
            <iframe src="https://www.youtube.com/embed/FidYHSgp9ss"
                title="YouTube video player" frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen controls=0></iframe>
            <h5>{{ 'video_tutorials_p_two' | translate }}</h5>
        </div>
        <div>
            <iframe src="https://www.youtube.com/embed/ORRuoDQxLDw"
                title="YouTube video player" frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen></iframe>
                <h5>{{ 'video_tutorials_p_three' | translate }}</h5>
        </div>
    </div>
</div>
